import { render, staticRenderFns } from "./addDrawer.vue?vue&type=template&id=907ade38&"
import script from "./addDrawer.vue?vue&type=script&lang=js&"
export * from "./addDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports